import { render } from "./_PageLayout.vue?vue&type=template&id=cbe46044"
import script from "./_PageLayout.vue?vue&type=script&lang=js"
export * from "./_PageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__